<template>
	<div id='mapId' style="width: 100%; min-height: 400px; margin: 0 auto; background: gray; text-align: justify;" v-resize="resize" :height="height">
		<slot></slot>
	</div>
</template>
<script>
	export default {
		name: 'Mapbox',
		props: ['name', 'height'],
		data() {
			return {
				mapId: this.name+'-map',
				// map: null, 
				bounds: null
			}
		},
		created(){
			this.map = null;
		},
		mounted(){
			var mapboxKey = 'pk.eyJ1IjoianVzdGlubXNoZXAiLCJhIjoiY2praGFucThsMHFrNDNxb3gzanExZmZrMiJ9.SJzutdGzBjRzG_pdFNvEGA';

			this.bounds = mapboxgl.LngLatBounds();

			mapboxgl.accessToken = mapboxKey;
			// This adds the map to your page

			this.map = new mapboxgl.Map({
			  // container id specified in the HTML
			  container: 'mapId',
			  // style URL
			  style: 'mapbox://styles/mapbox/streets-v11',
			  // initial position in [lon, lat] format
			  center: [-77.034084, 38.909671],
			  interactive: false,
			  // initial zoom
			  zoom: 14
			});

			this.map.on('render', () => {
				this.map.resize();
			})

			this.map.addControl(new mapboxgl.GeolocateControl({
				positionOptions: {
					enableHighAccuracy: true
				},
				trackUserLocation: true
			}))
		}, 
		methods: {
			getMap: function(found){
        var vm = this
        
        function checkForMap() {
          if(vm.map){
            found(vm.map);
          } else {
            setTimeout(checkForMap, 50)
          }
        }

        checkForMap();
      }, 
      resize: function(){
      }
		}
	}
</script>
<style>
</style>